/* =========================================================
   Velunna — global.js
   Sin dependencias. APIs nativas de Shopify:
   - Cart AJAX API (/cart/add.js, /cart/change.js, /cart.js)
   - Section Rendering API (?section_id= / sections=)
   - Predictive Search API (/search/suggest)
   - Product Recommendations API (/recommendations/products)
   ========================================================= */
(() => {
  const V = window.Velunna || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const html = (text) => { const d = document.createElement('div'); d.innerHTML = text; return d; };
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  }

  /* ---------- Drawers / modales ---------- */
  let lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-open')));
    document.body.classList.add('is-locked');
    const focusable = el.querySelector('input:not([type=hidden]), button, a[href]');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 50);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    setTimeout(() => {
      el.hidden = true;
      if (!$('.drawer.is-open, .modal.is-open, .search-overlay.is-open')) document.body.classList.remove('is-locked');
    }, 320);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { closeLayer(closer.closest('.drawer, .modal, .search-overlay')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open, .search-overlay.is-open').forEach(closeLayer);
  });

  /* ---------- Carrito ---------- */
  const cartDrawer = () => $('[data-cart-drawer]');
  async function refreshCart(sectionsHTML) {
    const cart = await fetch(V.routes.root.replace(/\/$/, '') + '/cart.js').then((r) => r.json());
    $$('[data-cart-count]').forEach((c) => {
      c.textContent = cart.item_count; c.hidden = cart.item_count === 0;
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
    let drawerHTML = sectionsHTML && sectionsHTML['cart-drawer'];
    if (!drawerHTML && cartDrawer()) {
      drawerHTML = await fetch(`${V.routes.root.replace(/\/$/, '')}/?section_id=cart-drawer`).then((r) => r.text());
    }
    if (drawerHTML && cartDrawer()) {
      const fresh = html(drawerHTML).querySelector('.drawer__panel');
      if (fresh) cartDrawer().querySelector('.drawer__panel').innerHTML = fresh.innerHTML;
      loadCartRecs();
    }
    return cart;
  }
  function openCart() {
    if (V.cartType === 'drawer' && cartDrawer()) openLayer(cartDrawer());
    else window.location.href = V.routes.cart;
  }
  async function addToCart(items, button) {
    if (button) button.classList.add('is-loading');
    try {
      const res = await fetch(V.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || V.strings.error);
      const lastProduct = data.items && data.items[0] ? data.items[0].product_id : null;
      if (lastProduct) cartDrawer()?.setAttribute('data-last-product', lastProduct);
      await refreshCart(data.sections);
      closeLayer($('#QuickView'));
      if (V.cartType === 'drawer') openCart(); else toast(V.strings.added);
      return true;
    } catch (err) {
      toast(err.message || V.strings.error);
      return false;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }
  async function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-loading');
    const res = await fetch(V.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok) { toast(data.description || V.strings.error); if (lineEl) lineEl.classList.remove('is-loading'); return; }
    if ($('[data-main-cart]')) { window.location.reload(); return; }
    await refreshCart(data.sections);
  }
  document.addEventListener('click', (e) => {
    const cartOpener = e.target.closest('[data-cart-open]');
    if (cartOpener && V.cartType === 'drawer' && cartDrawer()) { e.preventDefault(); openCart(); return; }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick); return; }

    const many = e.target.closest('[data-add-many]');
    if (many) {
      e.preventDefault();
      const items = many.dataset.addMany.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      addToCart(items, many); return;
    }

    const line = e.target.closest('[data-line-change]');
    if (line) { e.preventDefault(); changeLine(line.dataset.lineChange, Number(line.dataset.qty), line.closest('.cart-item')); }
  });

  /* Recomendaciones del carrito (Recommendations API) */
  async function loadCartRecs() {
    const box = $('[data-cart-recs]');
    if (!box) return;
    const productId = cartDrawer()?.dataset.lastProduct || box.dataset.productId;
    if (!productId) return;
    try {
      const url = `${V.routes.recommendations}?section_id=cart-recommendations&product_id=${productId}&limit=6&intent=related`;
      const text = await fetch(url).then((r) => r.text());
      const node = html(text).querySelector('.cart-recs');
      if (!node) return;
      const exclude = (box.dataset.exclude || '').split(',');
      $$('[data-product-id]', node).forEach((li) => { if (exclude.includes(li.dataset.productId)) li.remove(); });
      $$('.cart-rec', node).slice(3).forEach((li) => li.remove());
      if ($$('.cart-rec', node).length) box.replaceWith(node);
    } catch (e) {}
  }

  /* ---------- Formulario de producto (ficha y vista rápida) ---------- */
  function initProductForm(root) {
    $$('[data-product-form]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      const form = $('form', wrap);
      const idInput = $('[data-variant-id]', wrap);
      const addBtn = $('[data-add-button]', wrap);
      const addLabel = $('[data-add-label]', wrap);
      const variants = JSON.parse($('[data-variants]', wrap)?.textContent || '[]');
      const groups = $$('.variant-group', wrap);
      const section = wrap.closest('[data-product-section]');
      const scope = section || wrap.closest('[data-quick-view]') || document;
      const isMain = !!section;
      const sectionId = isMain ? section.dataset.sectionId : 'quick-view';

      const qty = $('[data-qty]', wrap);
      if (qty) {
        const input = $('input', qty);
        qty.addEventListener('click', (e) => {
          if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, Number(input.value) - 1);
          if (e.target.closest('[data-qty-plus]')) input.value = Number(input.value) + 1;
        });
      }

      const selected = () => groups.map((g) => $('input:checked', g)?.value);
      const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

      function markAvailability() {
        const current = selected();
        groups.forEach((g, gi) => {
          $$('input', g).forEach((input) => {
            const test = current.slice(); test[gi] = input.value;
            const v = findVariant(test);
            input.closest('.variant-pill').classList.toggle('is-unavailable', !v || !v.available);
          });
          const label = $('[data-option-selected]', g); if (label) label.textContent = current[gi];
        });
      }

      async function onChange() {
        const variant = findVariant(selected());
        markAvailability();
        if (!variant) {
          addBtn.disabled = true; addLabel.textContent = V.strings.unavailable; return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? V.strings.addToCart : V.strings.soldOut;
        const stock = $('[data-stock]', scope);
        if (stock) stock.innerHTML = variant.available ? `<span class="dot dot--ok"></span>${V.strings.inStock}` : `<span class="dot dot--off"></span>${V.strings.soldOut}`;
        const sticky = $('[data-sticky-add]'); if (isMain && sticky) sticky.disabled = !variant.available;
        if (isMain) {
          const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (variant.featured_media) goToMedia(scope, variant.featured_media.id);
        try {
          const text = await fetch(`${wrap.dataset.url}?variant=${variant.id}&section_id=${sectionId}`).then((r) => r.text());
          const doc = html(text);
          const fresh = $('[data-price-wrapper]', doc); const cur = $('[data-price-wrapper]', scope);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          const freshSticky = $('[data-sticky-price]', doc); const curSticky = $('[data-sticky-price]', scope);
          if (freshSticky && curSticky) curSticky.innerHTML = freshSticky.innerHTML;
        } catch (e) {}
      }
      groups.forEach((g) => g.addEventListener('change', onChange));
      if (groups.length) markAvailability();

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const quantity = Number($('input[name="quantity"]', form)?.value || 1);
        addToCart([{ id: Number(idInput.value), quantity }], addBtn);
      });
    });
  }

  /* ---------- Galería ---------- */
  function goToMedia(scope, mediaId) {
    const slide = $(`[data-media-id="${mediaId}"]`, scope);
    const track = slide && slide.closest('[data-gallery-track]');
    if (track) track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function initGallery(root) {
    $$('[data-gallery]', root).forEach((g) => {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      const track = $('[data-gallery-track]', g);
      const thumbs = $$('[data-thumb]', g);
      const count = $('[data-gallery-count]', g);
      thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(g, t.dataset.thumb)));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          const slide = track.children[i]; if (!slide) return;
          if (count) count.textContent = i + 1;
          thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === slide.dataset.mediaId));
          $$('video', track).forEach((v) => { if (!slide.contains(v) && !v.paused) v.pause(); });
        });
      }, { passive: true });
    });
  }

  /* ---------- Vista rápida ---------- */
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (!trigger || trigger.matches('.quick-view')) return;
    e.preventDefault();
    const modal = $('#QuickView'); const content = $('[data-quick-view-content]', modal);
    trigger.classList.add('is-loading');
    try {
      const url = trigger.dataset.quickView.split('?')[0];
      const text = await fetch(`${url}?section_id=quick-view`).then((r) => r.text());
      const node = html(text).querySelector('[data-quick-view]');
      content.innerHTML = ''; if (node) content.appendChild(node);
      initGallery(content); initProductForm(content); syncToggles(content);
      closeLayer(cartDrawer());
      openLayer(modal);
    } catch (err) { window.location.href = trigger.dataset.quickView; }
    finally { trigger.classList.remove('is-loading'); }
  });

  /* ---------- Búsqueda predictiva ---------- */
  const overlay = $('[data-search-overlay]');
  if (overlay) {
    const input = $('[data-search-input]', overlay);
    const results = $('[data-search-results]', overlay);
    const defaults = $('[data-search-default]', overlay);
    let ctrl, timer;
    document.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-search-open]');
      if (opener) { e.preventDefault(); closeLayer($('#MenuDrawer')); openLayer(overlay); }
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; defaults.hidden = false; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        const params = new URLSearchParams({ q, section_id: 'predictive-search', 'resources[type]': 'product,collection,query,page', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last', 'resources[options][fields]': 'title,product_type,variants.title,vendor,tag' });
        try {
          const text = await fetch(`${V.routes.predictiveSearch}?${params}`, { signal: ctrl.signal }).then((r) => r.text());
          const node = html(text).querySelector('.ps');
          results.innerHTML = node ? node.outerHTML : ''; defaults.hidden = !!node;
        } catch (err) { if (err.name !== 'AbortError') results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Recomendaciones de producto (carga diferida) ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach((box) => {
      const io = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting) return; io.disconnect();
        try {
          const text = await fetch(box.dataset.url).then((r) => r.text());
          const section = html(text).querySelector('.section');
          if (section) { box.replaceWith(section); initDynamic(section); } else box.remove();
        } catch (e) { box.remove(); }
      }, { rootMargin: '300px' });
      io.observe(box);
    });
  }

  /* ---------- Favoritos y comparador (localStorage, por navegador) ---------- */
  const WL = 'velunna:wishlist'; const CMP = 'velunna:compare';
  function syncToggles(root = document) {
    const wl = store.get(WL); const cmp = store.get(CMP).map((c) => c.handle);
    $$('[data-wishlist-toggle]', root).forEach((b) => b.setAttribute('aria-pressed', wl.includes(b.dataset.wishlistToggle)));
    $$('[data-compare-toggle]', root).forEach((b) => b.setAttribute('aria-pressed', cmp.includes(b.dataset.compareToggle)));
  }
  function renderCompareBar() {
    const bar = $('#CompareBar'); if (!bar) return;
    const items = store.get(CMP);
    bar.hidden = items.length === 0 || !!$('[data-compare-page]');
    $('[data-compare-items]', bar).innerHTML = items.map((i) => i.image ? `<img src="${i.image}" alt="${i.title}" width="40" height="40">` : '').join('');
  }
  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault(); const list = store.get(WL); const h = w.dataset.wishlistToggle; const i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      store.set(WL, list); syncToggles(); return;
    }
    const c = e.target.closest('[data-compare-toggle]');
    if (c) {
      e.preventDefault(); let list = store.get(CMP); const h = c.dataset.compareToggle;
      if (list.some((x) => x.handle === h)) list = list.filter((x) => x.handle !== h);
      else if (list.length >= 4) { toast(V.strings.compareMax); return; }
      else list.push({ handle: h, title: c.dataset.title, image: c.dataset.image });
      store.set(CMP, list); syncToggles(); renderCompareBar(); return;
    }
    if (e.target.closest('[data-compare-clear]')) { store.set(CMP, []); syncToggles(); renderCompareBar(); }
  });
  window.VelunnaStore = { store, WL, CMP, syncToggles, renderCompareBar, addToCart, initDynamic: (r) => initDynamic(r) };

  /* ---------- Carruseles ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]'); if (!btn) return;
    const track = btn.closest('.page-width').querySelector('[data-carousel]'); if (!track) return;
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Animaciones: reveal, 3D tilt, parallax ---------- */
  let io;
  function initReveal(root) {
    if (!V.animations || reduceMotion || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('anim');
    if (!io) io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('[data-reveal]:not(.is-in)', root).forEach((el) => io.observe(el));
  }
  function initTilt(root) {
    if (!V.tilt || reduceMotion || !finePointer) return;
    $$('[data-tilt]', root).forEach((el) => {
      if (el.dataset.tiltReady) return; el.dataset.tiltReady = '1';
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - 0.5; const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) translateY(-4px)`;
      });
      el.addEventListener('pointerleave', () => { el.style.transform = ''; });
    });
  }
  function initDynamic(root = document) { initReveal(root); initTilt(root); syncToggles(root); initProductForm(root); initGallery(root); }

  const header = $('[data-header]');
  const parallax = $('[data-parallax] .hero__img, [data-parallax] .hero__video');
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      if (header) header.classList.toggle('is-scrolled', y > 8);
      if (parallax && !reduceMotion && y < 1200) parallax.style.transform = `translate3d(0, ${y * 0.12}px, 0) scale(1.06)`;
      ticking = false;
    });
  }, { passive: true });

  /* Barra de anuncios rotativa */
  const ann = $('[data-announcement]');
  if (ann && ann.children.length > 1) {
    let i = 0; ann.children[0].classList.add('is-active');
    setInterval(() => { ann.children[i].classList.remove('is-active'); i = (i + 1) % ann.children.length; ann.children[i].classList.add('is-active'); }, 4500);
  }

  /* ---------- Arranque ---------- */
  initDynamic(document);
  initRecommendations();
  renderCompareBar();
  loadCartRecs();
})();
